<template>
    <div>
        <validation-provider
                :name="field.name"
                :rules="field.rules"
                v-slot="validationContext"
        >
            <b-form-group
                    :label-for="field.name"
                    :label="field.label + '\xa0'"
                    :id="'g_' + field.name"
                    class="mt-0"
            >
            <b-form-select
                    :options="field.options"
                    :id="field.name"
                    :state="getValidationState(validationContext)"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                    v-model="data.value"
                    :disabled="field.readonly"
            ></b-form-select>
                <small v-if="availabilityHint" class="text-info">{{availabilityHint}}</small>
                <h6 class="text-right">{{field.textAfter}}&#8288;</h6>
                <b-form-invalid-feedback
                        :id="'input-2-live-feedback' + field.name"
                >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>
    </div>
</template>

<script>
    export default {
        name: "SelectInput",
        props: {
            field: { required: true},
            data: { required: true }
        },
        computed: {
            availabilityHint() {
                if (this.field.hint) {
                    return this.field.hint;
                }

                const selected = this.field.options.find(
                    option => String(option.item) === String(this.data.value)
                );

                return selected ? selected.hint : null;
            }
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        }
    }
</script>

<style scoped>

</style>
